import { RESET_APP, RENDER_WEBSITE_PAGE, SET_WEBSITE_MENUS } from "../action-types/app";

// *******************************
//  RESET APP
// *******************************

export const resetApp = () => {
    return  {
        type: RESET_APP
    };
}

// *******************************
//  RENDER WEBSITE PAGE 
// *******************************

export const renderWebsitePage = (url) => {
    return  {
        type: RENDER_WEBSITE_PAGE,
        url: url
    };
}

// *******************************
//  SET WEBSITE MENUS 
// *******************************

export const setWebsiteMenus = (menus) => {
    return  {
        type: SET_WEBSITE_MENUS,
        menus: menus
    };
}